import React, {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field, formValueSelector} from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import axios from 'axios';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import generateValidator from './Validations/generateValidator';
import CustomSpinner from './CustomSpinner';
import CustomAlert from '../components/CustomAlert.js';
import CustomProgressBar from './CustomProgressBar';
import Section from './Section.js';
import Whatsapp from './WhatsappButton.js';
import UploaderField from './UploaderField.js';

class UploadForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            type: false,
            salary_type: false
        }
        this.getFilesPercentage = this.getFilesPercentage.bind(this);
        this.checkEmploymentType = this.checkEmploymentType.bind(this);
    }

    componentWillMount(){
        this.checkEmploymentType();
    }

    getFilesPercentage(){
        let {files} = this.props;
        let common_files = ['document_number_front', 'document_number_back', 'tax']
        if (this.state.type === 'work_dependence'){
            switch(this.state.salary_type){
                case 1:
                    common_files = common_files.concat(['cbu_document', 'last_pay_check']);
                    break;
                case 2:
                    common_files = common_files.concat(['cbu_document', 'first_half_month_paycheck_field', 'second_half_month_paycheck_field']);
                    break;
                default:
                    common_files = common_files.concat(['cbu_document', 'last_pay_check']);
                    break;
            }
        }else{
            common_files = common_files.concat(['net_incomes_paycheck']);
        }

        const currentFiles = files.filter((file) => file)
        return (currentFiles.length / common_files.length) * 100
    }

    checkEmploymentType(){
        const ROOT_URL = process.env.API_URL;

        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };
        /*TODO: REFACTOR this */
        axios.get(ROOT_URL + '/subscribers/employment_type', config)
            .then(res => {
                const data = res.data;
                this.setState({ type: data.type,
                                salary_type: data.salary_type});
            }
        );

    }

    componentDidMount

    render() {
        const { handleSubmit, submitting, error } = this.props;
        const cbu_document_field = (<Field name={'cbu_document'} label={'Comprobante de CBU Home Banking'} component={UploaderField}/>);
        const last_pay_check_field = (<Field name={'last_pay_check'} label={'Ultimo bono de sueldo'} component={UploaderField}/>);
        const first_half_month_paycheck_field = (<Field name={'first_half_month_paycheck_field'} label={'1º Quincena'} component={UploaderField}/>);
        const second_half_month_paycheck_field =  (<Field name={'second_half_month_paycheck_field'} label={'2º Quincena'} component={UploaderField}/>);
        const net_incomes_paycheck = (<Field name={'net_incomes_paycheck'} label={'IBB/IVA/Monotrib'} component={UploaderField}/>);
        const workDependenceDocumentsbyMonth = (<div>
                                                    {cbu_document_field}
                                                    {last_pay_check_field}    
                                                </div>);
        const workDependenceDocumentsbyHalfMonth = (<div>
                                                        {cbu_document_field}
                                                        {first_half_month_paycheck_field}
                                                        {second_half_month_paycheck_field}      
                                                    </div>);
        const selfEmploymentDocuments = (<div>
                                            {net_incomes_paycheck}
                                         </div>);
        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_upload_info" description="Job info"/>
                        <Whatsapp phone={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                  text={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                  value={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                  gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                        <p className="pd-opening-hours">Lunes a Viernes 09 - 17hs </p>
                    </div>
                    <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveFiles)} className="pvc-form form-horizontal">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <CustomProgressBar label={'Subí todos los archivos para completar el 100%!'} percentage={Math.round(this.getFilesPercentage())}/>
                            <div className='row'>

                                <Field name={'document_number_front'} label={'DNI Frente'} component={UploaderField}/>

                                <Field name={'document_number_back'} label={'DNI Dorso'} component={UploaderField}/>

                                <Field name={'tax'} label={'Impuesto o Servicio Actual'} component={UploaderField}/>    
 
                                {((this.state.type === 'self_employment') && selfEmploymentDocuments) || ((this.state.type === 'work_dependence') && ((this.state.salary_type === '1' && workDependenceDocumentsbyMonth) || (this.state.salary_type === '2' && workDependenceDocumentsbyHalfMonth)))}

                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={(this.getFilesPercentage() < 100) ||submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

UploadForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([{name: 'document_number_front', required: true, accepted_types:['jpg','pdf','png']},
                                  {name: 'document_number_back', required: true, accepted_types:['jpg','pdf','png']},
                                  {name: 'tax', required: true, accepted_types:['jpg','pdf','png']},
                                  {name: 'cbu_document', required: true, accepted_types:['jpg','pdf','png']},
                                  {name: 'last_pay_check', required: true, accepted_types:['jpg','pdf','png']},
                                  {name: 'first_half_month_paycheck_field', required: true, accepted_types:['jpg','pdf','png']},
                                  {name: 'second_half_month_paycheck_field', required: true, accepted_types:['jpg','pdf','png']},
                                  {name: 'net_incomes_paycheck', required: true, accepted_types:['jpg','pdf','png']}])

const selector = formValueSelector('UploadForm');

UploadForm = connect(
    state => {
        const document_number_front = selector(state, 'document_number_front');
        const document_number_back = selector(state, 'document_number_back');
        const tax = selector(state, 'tax');
        const cbu_document = selector(state, 'cbu_document');
        const last_pay_check = selector(state, 'last_pay_check');
        const first_half_month_paycheck_field = selector(state, 'first_half_month_paycheck_field');
        const second_half_month_paycheck_field = selector(state, 'second_half_month_paycheck_field');
        const net_incomes_paycheck = selector(state, 'net_incomes_paycheck');

        return {
            files: [document_number_front,
                   document_number_back,
                   tax,
                   cbu_document,
                   last_pay_check,
                   first_half_month_paycheck_field,
                   second_half_month_paycheck_field,
                   net_incomes_paycheck]
        }
    }
)(UploadForm)

UploadForm = TopScrolleable(UploadForm);

UploadForm = reduxForm({
    form: 'UploadForm', // a unique name for this form
    validate
})(UploadForm);

UploadForm = withAuthControl(UploadForm);

export default UploadForm;


/** WEBPACK FOOTER **
 ** ./src/components/UploadForm.js
 **/